'use client';

import { useEffect } from 'react';
import { useCookieConsent } from '@/platform/cookies/CookieConsentProvider';
import { getFirebaseAnalytics } from '../lib/firebase';

/** Initializes Firebase Analytics only when analytics consent is granted. */
export function FirebaseAnalytics() {
  const { consent, isReady } = useCookieConsent();

  useEffect(() => {
    if (!isReady || consent?.analytics !== true) return;
    void getFirebaseAnalytics();
  }, [isReady, consent?.analytics, consent?.decidedAt]);

  return null;
}
